import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const DashboardContainer = styled.div`
  min-height: 100%;
  position: relative;
  background: ${colors.bgScreen};
  padding: 44px 20px 15px 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const DashboardContent = styled.div``;

export const DashboardHeader = styled.div``;

export const DashboardHaderGrid = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DashboardHaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
  text-transform: uppercase;
`;

export const FadeContainer = styled.div`
  transition: ease-in-out .1s;
  opacity: ${prop => prop.fade ? '1' : '0'};
`;

export const DashboardEmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
`;

export const DashboardEmptyStateParagraph = styled.p`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.bgPrimary};
  margin-top: 20px;
`;
